import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { isNotFoundError } from "utils";

const retryUnlessNotFound = (failureCount: number, error: Error) =>
  !isNotFoundError(error) && failureCount < 3;

export const useConfirmationQueries = (guid?: string) => {
  const {
    data: customerConfirmation,
    error: confirmationError,
    isError: isConfirmationError,
    isFetching: isConfirmationFetching,
  } = useQuery({
    queryKey: ["confirmation", guid],
    queryFn: async () => {
      const result = await api.customers.getCustomerConfirmation(guid!);
      return result.data;
    },
    enabled: !!guid,
    retry: retryUnlessNotFound,
  });

  const {
    data: examDetails,
    isError: isExamDetailsError,
    isFetching: isExamDetailsFetching,
  } = useQuery({
    queryKey: ["examDetails", customerConfirmation?.examDateId],
    queryFn: async () => {
      const result = await api.exams.getExamDate(
        customerConfirmation!.examDateId
      );
      return result.data;
    },
    enabled: !!customerConfirmation?.examDateId,
  });

  const {
    data: paymentContext,
    error: paymentContextError,
    isError: isPaymentContextError,
    isFetching: isPaymentContextFetching,
  } = useQuery({
    queryKey: ["paymentContext", guid],
    queryFn: async () => {
      const result = await api.customers.getPaymentContext(guid!);
      return result.data;
    },
    enabled: !!guid,
    retry: retryUnlessNotFound,
  });

  return {
    customerConfirmation,
    examDetails,
    paymentContext,
    isNotFound:
      isNotFoundError(confirmationError) ||
      isNotFoundError(paymentContextError),
    isError: isConfirmationError || isExamDetailsError || isPaymentContextError,
    isFetching:
      isConfirmationFetching ||
      isExamDetailsFetching ||
      isPaymentContextFetching,
  };
};
